import { callAPI } from "../../config/AxiosTemplate";
import { API, COMMON_API_URL } from "../../constants/APIConstants";

export const getExternalReconciliationAction = (request, callback) => {
  callAPI(
    "getExternalReconciliationAction",
    API.getExternalReconciliation,
    "POST",
    request,
    (apiResponse) => {
      callback(apiResponse);
    }
  );
};

export const markExternalReconciliationStatusAction = (request, callback) => {
  callAPI(
    "markExternalReconciliationStatusAction",
    API.markPaidExternalReconciliation,
    "PATCH",
    request,
    (apiResponse) => {
      callback(apiResponse);
    }
  );
};

export const downloadExternalReconciliationAction = (
  url,
  request,
  callback,
  isDownloadFile
) => {
  callAPI(
    "downloadExternalReconciliationAction",
    COMMON_API_URL + url,
    "POST",
    request,
    (apiResponse) => {
      callback(apiResponse);
    },
    isDownloadFile
  );
};
